<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <ClientsTable />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClientsTable from "./tables/clientsTable.vue";

export default {
    components: {
        ClientsTable,
    },
    data: () => ({}),
    methods: {},
    mounted() {},
};
</script>

<style lang="scss" scoped></style>
